var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.435974 2.18404C0 3.03969 0 4.15979 0 6.4V11.6C0 13.8402 0 14.9603 0.435974 15.816C0.819467 16.5686 1.43139 17.1805 2.18404 17.564C3.03969 18 4.15979 18 6.4 18H11.6C13.8402 18 14.9603 18 15.816 17.564C16.5686 17.1805 17.1805 16.5686 17.564 15.816C18 14.9603 18 13.8402 18 11.6V6.4C18 4.15979 18 3.03969 17.564 2.18404C17.1805 1.43139 16.5686 0.819467 15.816 0.435974C14.9603 0 13.8402 0 11.6 0H6.4C4.15979 0 3.03969 0 2.18404 0.435974C1.43139 0.819467 0.819467 1.43139 0.435974 2.18404ZM14.4964 6.1699C14.8663 5.75986 14.8339 5.12753 14.4238 4.75755C14.0138 4.38757 13.3814 4.42005 13.0115 4.8301L7.39646 11.0531L4.45647 8.11841C4.0656 7.72824 3.43243 7.7288 3.04226 8.11968C2.65209 8.51055 2.65265 9.14372 3.04353 9.53389L6.72787 13.2116C6.92177 13.4052 7.18658 13.5107 7.46045 13.5036C7.73432 13.4964 7.99327 13.3772 8.1768 13.1738L14.4964 6.1699Z",
    fill: "#68AD18"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkboxOn.c5ee282885b00ea677a3995b3fa276a6.svg";